<h2 mat-dialog-title>
  {{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.TITLE' | translate }}
  <glxy-badge color="blue-solid" size="small">
    {{ 'AI_ASSISTANT.SHARED.BETA' | translate }}
  </glxy-badge>
</h2>

<mat-dialog-content>
  <p>
    <strong>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.INFORMATION_WARNING' | translate }}</strong>
    {{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.INFORMATION' | translate }}
  </p>
  <h4>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.EXAMPLE_HEADING' | translate }}</h4>
  <ol>
    <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.EXAMPLE_1' | translate }}</li>
    <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.EXAMPLE_2' | translate }}</li>
    <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.EXAMPLE_3' | translate }}</li>
    <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.EXAMPLE_4' | translate }}</li>
    <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.EXAMPLE_5' | translate }}</li>
    <li>
      {{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.EXAMPLE_6' | translate }}
      <ol type="a">
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_1' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_2' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_3' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_4' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_5' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_6' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_7' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_8' | translate }}</li>
        <li>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.FIELD_9' | translate }}</li>
      </ol>
    </li>
  </ol>
  <h4>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.DO_NOT_WORK_HEADING' | translate }}</h4>
  <p>{{ 'AI_ASSISTANT.SETTINGS.ADDITIONAL_INSTRUCTIONS_DIALOG.DO_NOT_WORK_DESCRIPTION' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
</mat-dialog-actions>
